import '@assets/styles/web-v3-styles/tables.scss';
import { Table } from "@radix-ui/themes";
import React from 'react';
import Paginations from './Paginations';

export default function Tables({
	columns = [],
	data = [],
	renderRow = () => { },
	pagination = false,
	totalPages = 1,
	current = 1,
	onChange,
	classNames,
	classNamePaginations,
	rowKey,
	stickyHeader = false,
	// fill: table co theo chiều cao cha (flex column) và tự cuộn khi vượt quá, thay cho max-height
	fill = false
}) {
	return (
		<div className={fill ? "min-h-0 flex flex-col" : ""}>
			<div
				className={`overflow-x-auto overflow-y-auto ${fill ? "min-h-0" : "max-h-[600px]"} scrollbar-h-2
            scrollbar-thin
            scrollbar-thumb-[#E6B97D]
            scrollbar-track-transparent ${stickyHeader ? "table-sticky-header" : ""} ${classNames}`}
			>
				<Table.Root className="min-w-max" variant="ghost">
					<Table.Header>
						<Table.Row>
							{columns?.map((column, index) => (
								<Table.ColumnHeaderCell
									key={`${column.key}-${index}`}
									className={`
										whitespace-nowrap
										text-[rgba(113,59,18,1)]
										font-bold
										text-[27px]
										leading-normal
										 ${column.className || ""}
										`}
								>
									{column.title}
								</Table.ColumnHeaderCell>
							))}
						</Table.Row>
					</Table.Header>

					<Table.Body className={`text-[25px]`}>
						{data?.map((item, index) =>
							<React.Fragment key={
								rowKey
									? rowKey(item, index)
									: item.id ?? item.key ?? index
							}>
								{renderRow(item)}
							</React.Fragment>
						)}
					</Table.Body>
				</Table.Root>
			</div>
			{
				pagination && (
					<Paginations
						current={current}
						totalPages={totalPages}
						onChange={onChange}
						classNamePaginations={classNamePaginations}
					/>
				)
			}
		</div >
	);
}